import ApiService from '../../components/api_services/apiService.jsx';
import { setMaxPages, setTotalCount, toggleCheckedItem } from '../../store/promoSlice';
import StatusBadge from '../../components/components/status_badge/StatusBadge.jsx';
import PromoActionDropdown from '../../components/components/promo_action_dropdown/PromoActionDropdown.jsx';
import { API_PLAN_TO_UI, UI_PLAN_TO_API, UI_STATUS_TO_API, formatPromotionDate, formatPromotionPeriod } from './promoUtils.js';

const mapApiPromotion = (promo) => ({
    id: promo.id,
    date: promo.createdAt,
    startsAt: promo.startsAt,
    endsAt: promo.endsAt,
    eventName: promo.eventName,
    organizer: promo.organizerName,
    categoryId: promo.categoryId,
    organizerId: promo.organizerId,
    eventId: promo.eventId,
    planType: promo.planType,
    promotionType: promo.planDisplayName || API_PLAN_TO_UI[promo.planType] || promo.planType,
    amount: Number(promo.amountPln || 0),
    transaction: promo.transaction,
    status: promo.statusLabel || promo.status?.toLowerCase(),
});

export const fetchPromotions = async (
    currentPage,
    sortBy,
    sortDirection,
    keyword,
    filters,
    dispatch,
    setRawPromotions
) => {
    const sortMap = {
        date: 'createdAt',
        amount: 'amount',
        id: 'id',
        promotionType: 'planType',
        status: 'status',
        eventName: 'createdAt',
    };

    const status = filters?.status ? UI_STATUS_TO_API[filters.status] : null;
    const promotionType = filters?.promotionType ? UI_PLAN_TO_API[filters.promotionType] : null;

    const response = await ApiService.getAdminPromotions(
        currentPage,
        8,
        sortMap[sortBy] || sortBy,
        sortDirection,
        status,
        promotionType,
        filters?.organizerId || null,
        filters?.dateFrom || null,
        filters?.dateTo || null
    );

    let promotions = (response.data || []).map(mapApiPromotion);

    if (keyword) {
        const lower = keyword.toLowerCase();
        promotions = promotions.filter((promo) =>
            promo.eventName?.toLowerCase().includes(lower) ||
            promo.organizer?.toLowerCase().includes(lower)
        );
    }

    dispatch(setTotalCount(response.totalItems || promotions.length));
    dispatch(setMaxPages(response.totalPages || 1));
    setRawPromotions(promotions);
};

export const mapPromotionsToRows = (promotions, checkedItems, dispatch, handlers = {}) => {
    return promotions.map((promo) => [
        <input
            key={`check-${promo.id}`}
            type="checkbox"
            checked={checkedItems.includes(promo.id)}
            onChange={() => dispatch(toggleCheckedItem(promo.id))}
        />,
        <div key={`id-${promo.id}`}>{String(promo.id).slice(0, 8)}</div>,
        <div key={`date-${promo.id}`}>{formatPromotionDate(promo.date)}</div>,
        <div key={`event-${promo.id}`} className="promo-event-cell">{promo.eventName}</div>,
        <span className="promo-organizer-cell" key={`promo-org-${promo.id}`}>
            {promo.organizer}
        </span>,
        <div key={`type-${promo.id}`}>{promo.promotionType}</div>,
        <div key={`period-${promo.id}`} className="promo-period-cell">
            {formatPromotionPeriod(promo.startsAt, promo.endsAt)}
        </div>,
        <div key={`amount-${promo.id}`}>{promo.amount.toFixed(2)}</div>,
        <div key={`tx-${promo.id}`}>{promo.transaction}</div>,
        <StatusBadge key={`status-${promo.id}`} status={promo.status} />,
        <PromoActionDropdown
            key={`actions-${promo.id}`}
            promo={promo}
            onRenew={handlers.onRenew}
            onPromote={handlers.onPromote}
            onDelete={handlers.onDelete}
        />,
    ]);
};
